import { render, staticRenderFns } from "./HourRentDetail.vue?vue&type=template&id=2b2a5f14&scoped=true&"
import script from "./HourRentDetail.vue?vue&type=script&lang=js&"
export * from "./HourRentDetail.vue?vue&type=script&lang=js&"
import style0 from "./HourRentDetail.vue?vue&type=style&index=0&id=2b2a5f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a5f14",
  null
  
)

export default component.exports